import React, { useEffect } from "react";

// Custom hook
export default function (interval = 5000, onData) {
   useEffect(() => {
  let isMounted = true;

  const intervalId = setInterval(async () => {
    if (!isMounted) return;
    try {
      await onData();
    } catch (err) {
      console.error(err);
    }
  }, interval);

  return () => {
    isMounted = false;
    clearInterval(intervalId);
  };
}, [interval, onData]);

}
